var friendbuyAPI;

window["friendbuyAPI"] = friendbuyAPI = window["friendbuyAPI"] || [];

// registers your merchant using your merchant ID found in the
// retailer app https://retailer.friendbuy.io/settings/general
friendbuyAPI.merchantId = "2e5d4299-2768-4535-862e-3e990dbad9fb";
friendbuyAPI.push(["merchant", friendbuyAPI.merchantId]);

// load the merchant SDK and your campaigns
(function (f, r, n, d, b, u, y) {
  while ((u = n.shift())) {
    (b = f.createElement(r)), (y = f.getElementsByTagName(r)[0]);
    b.async = 1;
    b.src = u;
    y.parentNode.insertBefore(b, y);
  }
})(document, "script", [
  "https://static.fbot.me/friendbuy.js",
  "https://campaign.fbot.me/" + friendbuyAPI.merchantId + "/campaigns.js",
]);

